import { useEffect, useState } from 'react';
import { Form, Input, Select, DatePicker, Switch, Button, Card, Row, Col, message, Space, Alert } from 'antd';
import { SaveOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined, UploadOutlined } from '@ant-design/icons';
import AdminSidebar from '../Components/Sidebar';
import TextArea from 'antd/es/input/TextArea';
import { createOrUpdateSettings, getSettings } from '../redux/slices/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import Upload from 'antd/es/upload/Upload';

function TaxForm() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [fileList, setFileList] = useState([]);
    const dispatch = useDispatch();

    const onReset = () => {
        form.resetFields();
        message.info('Form has been reset');
    };

    const { settings } = useSelector((state) => state?.settings)

    useEffect(() => {
        dispatch(getSettings())
    }, [dispatch])

    useEffect(() => {
        // if (settings?.data) {
        //     form.setFieldsValue({
        //         tax_form : settings?.data?.tax_form
        //     })
        // }
        if (settings?.data) {
            form.setFieldsValue({
              tax_form: settings.data.tax_form,
            });
      
            if (settings.data.tax_form) {
              setFileList([
                {
                  uid: '-1', // required unique id
                  name: settings.data.tax_form.split('/').pop(), // show filename
                  status: 'done',
                  url: settings.data.tax_form, // file URL (for preview/download)
                },
              ]);
            }
        }
    }, [settings, form])

    const handleChange = (info) => {
        setFileList(info.fileList);
    };

    const beforeUpload = (file) => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
            setAlertMessage('You can only upload PDF files!');
            setAlertType('error');
            setTimeout(() => {
                setAlertMessage('')
                setAlertType('')
            }, 4000)
            return Upload.LIST_IGNORE; // Prevent adding to file list
        }
        return false; // Prevent auto upload, but allow manual submit
    };

    const onSubmit = async (values) => {
        setLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const file = values?.tax_form?.fileList?.[0]?.originFileObj
            const isPDF = file?.type === 'application/pdf';

            if (file == null) {
                setAlertMessage('Upload file!');
                setAlertType('error');
                setTimeout(() => {
                    setAlertMessage('')
                    setAlertType('')
                }, 4000)
                return
            } else if (!isPDF) {
                //   message.error('You can only upload PDF files!');
                setAlertMessage('You can only upload PDF files!');
                setAlertType('error');
                setTimeout(() => {
                    setAlertMessage('')
                    setAlertType('')
                }, 4000)
                return
            }



            const formData = new FormData();
            console.log(file, fileList[0].originFileObj)
            formData.append('type', 'Tax Form');
            formData.append('tax_form', file);

            const resultAction = await dispatch(createOrUpdateSettings(formData));

            if (createOrUpdateSettings.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message);
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('')
                    setAlertType('')
                }, 4000)
            } else {
                setAlertMessage(resultAction?.payload?.error || 'Failed to update tax form');
                setAlertType('danger');
            }

        } catch (error) {
            setAlertMessage('Failed to update tax form');
            setAlertType('danger');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                title="Terms and Conditions"
                style={{ marginBottom: 24 }}
            >
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                    initialValues={{
                        status: 'active',
                        notifications: true,
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Tax Form"
                        name="tax_form"
                    >
                        {/* <TextArea
                            rows={4}
                            placeholder="Enter Terms and Conditions"
                        /> */}
                        <Upload
                            beforeUpload={beforeUpload} // prevent auto-upload
                            fileList={fileList}
                            maxCount={1}
                            accept='.pdf'
                            listType='text'
                            onChange={handleChange}
                            // onClick={() => {
                            //     const link = document.createElement('a');
                            //     link.href = settings.data.tax_form; // full file URL
                            //     link.download = settings.data.tax_form.split('/').pop(); // optional filename
                            //     document.body.appendChild(link);
                            //     link.click();
                            //     document.body.removeChild(link);
                            // }}
                            onPreview={(file) => {
                                // console.log(file.url)
                                window.open(file.url, '_blank');
                                return false
                            }}
                        >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>

                    </Form.Item>

                    <Form.Item>
                        <Space>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                                loading={loading}
                                size="large"
                            >
                                Submit
                            </Button>
                            <Button
                                htmlType="button"
                                onClick={onReset}
                                size="large"
                            >
                                Reset
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
            } />
            
        </>
    );
}

export default TaxForm;